import {
    ITravelData,
    ITravelFilterDataExtended,
    IListResponse,
    IAccommodationData,
    ILocationData,
    ITasteData,
    ITypeData,
    ISeasonData,
    IRequestExtended,
    ITravelLimits
} from '../../entities'
import {
    ITravelService
} from './index'
import axios, {
    AxiosInstance,
    AxiosResponse
} from 'axios'
import {
    defaultConfig
} from '../config'
import { store } from '@/main';
import { isEqual } from 'lodash';
import { TravelFormat } from '@/entities/abstract/travelFormat.model';


export class TravelService implements ITravelService {
    constructor(private readonly axios: AxiosInstance) {}

    async getAll(data?: IRequestExtended<ITravelFilterDataExtended>, language?: string): Promise<AxiosResponse<IListResponse<ITravelData[]>>> {
        let config = data?.config;
        if (config) {
            let api = axios.create(config);
            return api({
                ...defaultConfig(language),
                ...config
            });
        } else {
            if (data?.payload?.travel_format?.length) {

                let result: TravelFormat[] = [];
                data?.payload?.travel_format?.map((item) => {
                    
                    if (isEqual(item, 'Групповые | Групповое')
                        || isEqual(item, 'group')
                        || isEqual(item, 'Group')) {
                        result.push('group');
                    }
                    if (isEqual(item, 'Путеводители | Путеводитель')
                        || isEqual(item, 'Single')
                        || isEqual(item, 'single')) {
                        result.push('single');
                    }
                    if (isEqual(item, 'Индивидуальные | Индивидуальное')
                        || isEqual(item, 'Individual')
                        || isEqual(item, 'individual')) {
                        result.push('individual');
                    }
                });
                data.payload.travel_format = result;
            }

            return this.axios.get('/travel/', {
                ...defaultConfig(language),
                params: data?.payload
            });
        }
    }

    async getById(id: number, language?: string): Promise<AxiosResponse<ITravelData | undefined>> {
        this.axios.get(`/travel/${ id }/`, defaultConfig(language)).then((res) => {
            store.dispatch('setGroupTravel', res.data);
        });

        return this.axios.get(`/travel/${ id }/`, defaultConfig(language))
    }

    async getLimits(): Promise<AxiosResponse<ITravelLimits>> {
        return this.axios.get('/travel/max_values/')
    }

    // criteria
    async getAllAccommodation(language?: string): Promise<AxiosResponse<IListResponse<IAccommodationData[]>>> {
        return this.axios.get('/accommodation/', defaultConfig(language))
    }
    async getAccommodationById(id: number, language?: string): Promise<AxiosResponse<IAccommodationData | undefined>> {
        return this.axios.get(`/accommodation/${ id }/`, defaultConfig(language))
    }

    async getAllTravelType(language?: string): Promise<AxiosResponse<IListResponse<ITypeData[]>>> {
        return this.axios.get('/travel_type/', defaultConfig(language))
    }
    async getTravelTypeById(id: number, language?: string): Promise<AxiosResponse<ITypeData | undefined>> {
        return this.axios.get(`/travel_type/${ id }/`, defaultConfig(language))
    }

    async getAllTaste(language?: string): Promise<AxiosResponse<IListResponse<ITasteData[]>>> {
        return this.axios.get('/taste/', defaultConfig(language))
    }
    async getTasteById(id: number, language?: string): Promise<AxiosResponse<ITasteData | undefined>> {
        return this.axios.get(`/taste/${ id }/`, defaultConfig(language))
    }

    async getAllLocation(language?: string): Promise<AxiosResponse<IListResponse<ILocationData[]>>> {
        return this.axios.get('/location/', defaultConfig(language))
    }
    async getLocationById(id: number, language?: string): Promise<AxiosResponse<ILocationData | undefined>> {
        return this.axios.get(`/location/${ id }/`, defaultConfig(language))
    }

    async getAllSeason(language?: string): Promise<AxiosResponse<IListResponse<ISeasonData[]>>> {
        return this.axios.get('/season/', defaultConfig(language))
    }
    async getSeasonById(id: number, language?: string): Promise<AxiosResponse<ISeasonData | undefined>> {
        return this.axios.get(`/season/${ id }/`, defaultConfig(language))
    }

}